import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getAllWorkingDayTypes = async ({ companyCode, isTrue=true }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.WorkingDaysType}?isAll=true&isTrue=${isTrue}&CompanyCode=${companyCode}`
  );
  return data;
};

const getWorkingDaysTypeById = async ({ companyCode, code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.WorkingDaysType}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

const insertWorkingDaysType = async (input) => {
  const { data } = await http_payroll.post(Api_EndPoints.WorkingDaysType, input);
  return data;
};

const updateWorkingDaysType = async (input) => {
  const { data } = await http_payroll.put(Api_EndPoints.WorkingDaysType, input);
  return data;
};

const deleteWorkingDaysType = async ({ companyCode, code }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.WorkingDaysType}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

export const useGetWorkingDayTypesQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.WorkingDaysType],
    queryFn: () => getAllWorkingDayTypes(input),
    refetchOnWindowFocus: false,
  });
};

export const useGetWorkingDaysTypeByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.WorkingDaysType],
    queryFn: () => getWorkingDaysTypeById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertWorkingDaysTypeMutation = () => {
  return useMutation({
    mutationFn: insertWorkingDaysType,
  });
};

export const useUpdateWorkingDaysTypeMutation = () => {
  return useMutation({
    mutationFn: updateWorkingDaysType,
  });
};

export const useDeleteWorkingDaysTypeMutation = () => {
  return useMutation({
    mutationFn: deleteWorkingDaysType,
  });
};
